/**
 * The per-edge segment layer: every edge segment on every primary edge, in
 * edge order then segment-index order. Doors / windows / openings render
 * through SegmentGlyph; alcoves through AlcoveItem.
 */

import { EDGE_NAMES, edgeFrame, FloorPlanRoom, Point } from '@kaiizen/kai-floor-plan';
import { alongCursor, edgeWorld, EditorMutableState, isLineSegmentSelected, primaryEdgeLineFrame } from '@kaiizen/kai-floor-plan-editor-core';
import { Fragment } from 'react';
import { AlcoveItem } from './AlcoveItem';
import { SegmentGlyph } from './SegmentGlyph';

export interface EdgeItemsProps {
  st: EditorMutableState;
  s: FloorPlanRoom;
  sp: (p: Point) => Point;
  scale: number;
}

export function EdgeItems({ st, s, sp, scale }: EdgeItemsProps): React.JSX.Element {
  return (
    <>
      {EDGE_NAMES.map(edge => {
        const fr = edgeFrame(edge, s.width, s.length);
        const peLf = primaryEdgeLineFrame(s, edge);
        const sideCur = alongCursor(peLf.perp); // slides along the edge
        return (
          <Fragment key={edge}>
            {(s[edge]?.segments ?? []).map((al, i) => {
              if (al.edgeSegmentType !== 'alcove') {
                const wfn = (ss: number, o: number) => edgeWorld(s, edge, ss, o);
                const segActive = isLineSegmentSelected(st.selection, { k: 'pe', edge }, i);
                return (
                  <SegmentGlyph
                    key={i}
                    wfn={wfn}
                    perp={{ x: fr.perp.x, y: fr.perp.y }}
                    seg={al}
                    bodyHandle={`ls:pe:${edge}:${i}`}
                    startHandle={`ls-s:pe:${edge}:${i}`}
                    endHandle={`ls-e:pe:${edge}:${i}`}
                    delHandle={`ls-d:pe:${edge}:${i}`}
                    active={segActive}
                    sp={sp}
                    scale={scale}
                  />
                );
              }
              return <AlcoveItem key={i} st={st} s={s} edge={edge} index={i} al={al} sideCur={sideCur} sp={sp} scale={scale} />;
            })}
          </Fragment>
        );
      })}
    </>
  );
}
